import { boolean, nullable, partial, string } from 'io-ts/Decoder';

import { Type as UISettings } from '../../../../../user/preferences/ui-settings/Type';

export const Request = partial({
	name: string,
	description: nullable(string),
	//
	settings: UISettings,
	//
	isFavourite: boolean,
});
